jQuery(function() {
  var viewportWidth = window.viewportSize.getWidth();
    var mobile = false;
    var tablet = false;
    var desktop = false;
    function checkWidth() {
      if (viewportWidth <= 660) {
        if (!mobile) {
          $('body').addClass('mobile').removeClass('desktop');
          $('body.pgCategory h1').prependTo('.content');
          $('body.pgProduct h1').insertAfter('ul.breadcrumb');
          $('.holiday-shipping').insertBefore('.header');
          $('body.pgProduct ul.slides li a').contents().unwrap();
        }
        mobile = true;
        desktop = false;
        tablet = false;
      }
      else if (viewportWidth >= 661 && viewportWidth <= 960) {
        if (!tablet) {
          $('body').removeClass('mobile dekstop').addClass('tablet');
          $('body.pgCategory h1').prependTo('.tagline');
          $('body.pgProduct h1').prependTo('.cart-handler');
          $('.holiday-shipping').prependTo('.header');
        }
        mobile = false;
        desktop = false;
        tablet = true;
      }
      else {
        if (!desktop) {
          $('body').removeClass('mobile').addClass('desktop');
          $('body.pgCategory h1').prependTo('div.tagline');
          $('body.pgProduct h1').prependTo('div.cart-handler');
          $('div.holiday-shipping').prependTo('div.header');
        }
        mobile = false;
        desktop = true;
        tablet = false;
      }
    }
    checkWidth();
    $(window).on("resize", checkWidth);

  /* Menus*/
    function toggleSites() {
      $('.global-sites li ul').slideToggle('fast');
      $('#btn_global').toggleClass('sites-active sites-inactive');
    }
	function toggleTopNav(){
		$("#btn-main-nav").toggleClass('activated inactive');
		$('ul.top-nav').slideToggle('fast');
		$('body').toggleClass('menu-open');  
	}
    $('html').on("click", function() {
    if ($("ul.top-nav").not(".desktop ul.top-nav").is(":visible")) {
       $("ul.top-nav").not('.mobile ul.top-nav').slideUp('fast'); 
       $("#btn-main-nav").not('.mobile #btn-main-nav').toggleClass('inactive activated');
       $('body').not('body.mobile').toggleClass('menu-open');
    }
  });
    $("#btn_global").on("click", function() {
      if ($("ul.top-nav").not('body.desktop ul.top-nav').is(":visible")) {
        toggleTopNav();
      } 
        toggleSites();
    });
  $('.global-sites > li > p, #btn-main-nav').on("click", function(event) {
    event.stopPropagation();
  });
  
    function closeLeftNav() {
      $("#btn-left-nav").toggleClass('leftnav-active leftnav-inactive ').next().removeClass('nav-opened');
    }  
    $("#btn-main-nav").on("click", function() {
		if ($(".global-sites li ul").is(":visible")) {
        toggleSites();
	  } 
		toggleTopNav();
    });  
      
  $("#btn-left-nav").on("click", function() {
      if ($(this).hasClass("leftnav-inactive")) {
        $("div.left-nav").animate({
          left: '0px'
        }, 200, 'linear');
        $(this).toggleClass('leftnav-inactive leftnav-active').next().addClass('nav-opened');
      } else {
        $("div.left-nav").animate({
          left: '-350px'
        }, 200, 'linear');
         closeLeftNav();
      }
      return false;
    });     

  //Product Page Item description collapse and tabs
  $(function () {
    $("#tabs > div").hide();
    $("#tabs > div:first").show();
    $("#tabs > span.tab-buttons button:first").addClass("active");
    $("#tabs > span.tab-buttons button").on("click", function () {
      $("#tabs > span.tab-buttons button").attr("class", "");
      $("#tabs > span.tab-buttons button").attr("tabindex", "-1");
      $("#tabs > span.tab-buttons button").attr("aria-selected", "false");
      $(this).attr("class", "active");
      $(this).attr("tabindex", "0");
      $(this).attr("aria-selected", "true");
      var currentTab = $(this).attr("aria-controls");
      $("#tabs > div").hide();
      $(`#${currentTab}`).show();
      return false;
    });
  });

  /*Fancybox*/
  $('.item-image .slides li a, .fancybox').fancybox({
    openEffect: 'elastic',
    openSpeed: 350,
    closeEffect: 'elastic',
    closeSpeed: 350,
    nextEffect: 'fade',
    nextSpeed: 200,
    padding:2,
    margin:20
  });

  // ADA AAA
  var $dropdowns = $("#main-nav .dropdown");
  var $dropdownsLinks = $("#main-nav .dropdownLink");
  $dropdownsLinks.on("focus",function(){
    let $thisParent = $(this).parent();
    $dropdowns.removeClass("open");
    $dropdownsLinks.attr("aria-expanded", "false");
    $thisParent.addClass("open");
    $(this).attr("aria-expanded", "true");
  })

  let fitstNavChild = $("#main-nav [role=menuitem]").first()[0];
  $(fitstNavChild).on("keydown", function(e) {
    if(e.key === 'Tab' && e.shiftKey) {
      $dropdowns.removeClass("open");
      $dropdownsLinks.attr("aria-expanded", "false");
    }
  })

  let lastNavChild = $("#main-nav [role=menuitem]").last()[0];
  $(lastNavChild).on("keydown", function(e) {
    if(e.key === 'Tab') {
      $dropdowns.removeClass("open");
      $dropdownsLinks.attr("aria-expanded", "false");
    }
  })
  
/* Promo Headers - */

   $.fn.flowtype = function(options) {
      var settings = $.extend({
         maximum   : 9999,
         minimum   : 1,
         maxFont   : 9999,
         minFont   : 1,
         fontRatio : 35
      }, options),
      changes = function(el) {
         var $el = $(el),
            elw = $el.width(),
            width = elw > settings.maximum ? settings.maximum : elw < settings.minimum ? settings.minimum : elw,
            fontBase = width / settings.fontRatio,
            fontSize = fontBase > settings.maxFont ? settings.maxFont : fontBase < settings.minFont ? settings.minFont : fontBase;
         $el.css('font-size', fontSize + 'px');
      };

      return this.each(function() {
         var that = this;
         $(window).on("resize", function(){changes(that);});
         changes(this);
      });
   };
/* Promo Banners */
	
		$('#hdr-banner p').flowtype({
		   minimum   : 420,
		   maximum   : 1200,
		   minFont   : 16,
		   //maxFont   : 45,
		   fontRatio : 35
		   });
		$('#hdr-banner p.banner1').flowtype({
		   minimum   : 420,
		   maximum   : 1200,
		   minFont   : 16,
		   //maxFont   : 45,
		   fontRatio : 40
		   });
	
			
  /*Detections*/
  var root = document.getElementsByTagName('html')[0];
  if (!document.createElement('svg').getAttributeNS) {
    root.setAttribute("class", "no-svg");
    return;
  }
  /* IE 10 Detection due to checkbox issues*/
  if (Function('/*@cc_on return document.documentMode===10@*/')()) {
    document.documentElement.className += ' ie10';
  }

const isHomePage = !!document.getElementById('pgHome');
//* Winter HP Section
if ((viewportWidth >= 961) && isHomePage) {
  jQuery.fn.threesixty = function(options){
    options = options || {};
    options.images = options.images || [];
    options.method = options.method || "click";//can be click, mouse move or auto
    options.cycle = options.cycle || 1;
    options.resetMargin = options.resetMargin || 0;
    options.direction = options.direction || "forward";
    options.sensibility = options.sensibility || options.cycle * 0.35;
    options.autoscrollspeed = options.autoscrollspeed || 500;
  
    if (options.direction == "backward")
      options.images.reverse();
  
      return this.each(function(){
      var imgArr = [];
      var pic = $(this);
  
    $(function() {
      var cache = [];
      var parent = $("<div>");
      parent.css({height:pic.height(), width:pic.width(), overflow:"hidden", position:"relative"});
      pic.wrap(parent).css({position:"relative",top:0,left:0});
      parent = pic.parent();
      //Binding the progress bar
      var progressBg = $("<div></div>").css({width:parent.width()-200, height:10, backgroundColor:"rgba(20, 75, 120, 1)", position:"absolute","bottom":60,left:100 }).addClass("progressBg");
      var progressBar = $("<div></div>").css({width:0, height:10, backgroundColor:"white", position:"absolute","bottom":60,left:100 }).data("progress",0).addClass("progressBar");
      var overlay;
      try {
       overlay = $("<div></div>").css({cursor:"wait", width:pic.width(), background:"RGBA(0,0,0,0)", height:pic.height(),  position:"absolute","top":0,left:0 }).addClass("overlay");
      }
      catch (e)
      {
       overlay = $("<div></div>").css({cursor:"wait", width:pic.width(), height:pic.height(), backgroundColor:"black", filter:"alpha(opacity=70)",  position:"absolute","top":0,left:0 }).addClass("overlay");		
      }
  
      // //bug where the overlay capturing all the events 
      // overlay.click(function(e) { e.preventDefault(); e.stopPropagation(); });
      // overlay.mousedown(function(e) { e.preventDefault(); e.stopPropagation(); });
      // parent.append(overlay).append(progressBg).append(progressBar);
      // pic.css({cursor:"all-scroll"});
      // var totalProgress = 0;
      // var loaded=false;
      // $.each(options.images, function(index, record) {
      // 	var o =$("<img>").attr("src",record).load(function() {
      // 		if (index>pic.data("tempIndex"))
      // 		{
      // 			pic.data("tempIndex", index)
      // 			pic.attr("src", $(this).attr("src"))
      // 		}	
  
      // 		var progress = pic.parent().find(".progressBar");
      // 		totalProgress++;
      // 		var maxsize = pic.parent().find(".progressBg").width();
      // 		var newWidth = (totalProgress/options.images.length)*maxsize;
      // 		progress.stop(true,true).animate({width:newWidth},250);
      // 		if (totalProgress == options.images.length-1)
      // 		{	loaded=true;
      // 			pic.parent().find(".overlay, .progressBar, .progressBg").remove();
      // 		}
      // 	});
      // 	cache.push(o); 
      // });
  
    })
      
      for (var x=1; x<=options.cycle; x++)
        for (var y=0; y<options.images.length; y++)
          imgArr.push(options.images[y]);
  
      pic.data("currentIndex",0).data("tempIndex",0);
      pic.data("scaled",false);
      pic.data("touchCount",0);
      var originalHeight = pic.height();
      var originalWidth = pic.width();
  
      function determineIndex(e)	//e represent the event for newIndex
      {
        return Math.floor((e.pageX - pic.offset().left) / (pic.width()/imgArr.length))
      }
  
      function moveInViewport(e) //e represents the finger in question
      {		$("#debug").text("left:" + e.pageX);
          var newTop = pic.data("refLocY") - pic.data("refTouchY") + e.pageY;
          var newLeft = pic.data("refLocX") - pic.data("refTouchX") + e.pageX;
          if (newLeft>0) newLeft=0;
          if (pic.parent().width() + Math.abs(newLeft) > pic.width())
            newLeft = -1*pic.width()+pic.parent().width();
          if (newTop>0) newTop=0;
          if (pic.parent().height() + Math.abs(newTop) > pic.height())
            newTop = -1*pic.height()+pic.parent().height();
    
          pic.css({left:newLeft, top:newTop});
      }
  
      pic.on("mousemove", function(evt) {
        if (!!pic.data("refTouchX") === false)
        {
          pic.data("refTouchX",evt.pageX);
          pic.data("refTouchY",evt.pageY);
          pic.data("refLocX",parseInt(pic.css("left")));
          pic.data("refLocY",parseInt(pic.css("top")));
        
        }
  
         evt.preventDefault();
         if (pic.data("enabled")=="1" || options.method == "mousemove")
        {	
          if (evt.preventDefault) evt.preventDefault();
    
          var e = evt;
          if (pic.data("scaled") == false)
          {
            var distance = e.pageX - pic.data("refTouchX");	//distance hold the distance traveled with the finger so far..
            var stripeSize = Math.floor(originalWidth / imgArr.length);
            var newIndex = pic.data("currentIndex") + Math.floor(distance*options.sensibility/stripeSize)
            if (newIndex < 0) 
            {
              newIndex = imgArr.length-1;
              pic.data("currentIndex",newIndex);
            }
            newIndex = newIndex % imgArr.length;
            if (newIndex == pic.data("currentIndex"))
              return;
            pic.attr("src",imgArr[newIndex]);
            pic.data("tempIndex",newIndex);		
          }
          else {	//The image needs to be moved in its viewport..
            moveInViewport(e);
          } 
          return;
        }
      });
      
      if (options.method == "click")
      {  
        pic.mousedown(function(e) {
          e.preventDefault(); 
          pic.data("enabled","1"); 	
        });	
    
        $("body").mouseup(function(e) {
           e.preventDefault();
           pic.data("enabled","0");
          pic.data("currentIndex",pic.data("tempIndex"));
        });
      }
      
      if (options.method == "auto") {
        var speed = options.autoscrollspeed;
        var newIndex=0;
        window.setInterval(function() { pic.attr("src", imgArr[++newIndex % imgArr.length])} , speed);
      }
    });	
  };
  /*Sliding in text*/
  function getBrowser() {
    var matched = uaMatch( navigator.userAgent );
    var browser = {};
    if ( matched.browser ) {
      browser[ matched.browser ] = true;
      browser.version = matched.version;
    }
    // Chrome is Webkit, but Webkit is also Safari.
    if ( browser.chrome ) {
      browser.webkit = true;
    } else if ( browser.webkit ) {
      browser.safari = true;
    }
    return browser;
  }
  
  function uaMatch(ua) {
    ua = ua.toLowerCase();
  
    var match = /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
      /(webkit)[ \/]([\w.]+)/.exec( ua ) ||
      /(opera)(?:.*version|)[ \/]([\w.]+)/.exec( ua ) ||
      /(msie) ([\w.]+)/.exec( ua ) ||
      ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec( ua ) ||
      [];
  
    return {
      browser: match[ 1 ] || "",
      version: match[ 2 ] || "0"
    };
  }
  $(function() {
  /*Animations*/
    /* Animations */
     $(' #pgHome div.content .wrap h2').addClass("hidden").viewportChecker({
        classToAdd: 'visible anim fadeInDown', 
        offset: 100    
     });  
     $('.main-hp div div *, #pgHome div.content h3, #pgHome div.content .wrap p, #pgHome div.tagline *,div.ice-products h3').addClass("hidden").viewportChecker({
        classToAdd: 'visible anim fadeInUp', 
        offset: 100    
     });   
     $('div.ice-logo, div.polar-bear').addClass("hidden").viewportChecker({
        classToAdd: 'visible anim fadeInLeft', 
        offset: 100    
     });  
        
      /* Ice HP Rotation Images*/
          var arr = [];
        for (var x=1; x<= 8; x++)
          arr.push("images/ice/polarbear/Gaylord-ICE-Plush-Polar-Bear_" +x + ".png");
        
        var arr2 = [];
        for (var x=1; x<= 8; x++)
          arr2.push("images/ice/globe/Gaylord-ICE-Globe-LED-Ornament_" +x + ".png");
        
        var arr3 = [];
        for (var x=1; x<= 8; x++)
          arr3.push("images/ice/bottle/Gaylord-ICE-Bottle_" +x + ".png");
        
        $("#polarbear")
          .threesixty({images:arr, method:'mousemove', 'cycle':1, direction:"forward", sensibility: 1})
          .on({'mouseout': function(){
                $(this).attr('src','images/ice/polarbear/Gaylord-ICE-Plush-Polar-Bear_8.png')}
          });
        $("#globe")
          .threesixty({images:arr2, method:'mousemove', 'cycle':1, direction:"forward", sensibility: 1})
          .on({'mouseout': function(){
                $(this).attr('src','images/ice/globe/Gaylord-ICE-Globe-LED-Ornament_8.png')}
          });
        $("#bottle")
          .threesixty({images:arr3, method:'mousemove', 'cycle':1, direction:"forward", sensibility: 1})
          .on({'mouseout': function(){
                $(this).attr('src','images/ice/bottle/Gaylord-ICE-Bottle_8.png')}
         });
    
    });
  }
  /*Doc Ready End*/
});

$(function() {
  function positionSearch() {
    if(window.matchMedia("(min-width:768px)").matches) {
      $('div.header p.search').insertBefore('div.header .utilities .shop-cart');
      $('.header-inner nav').insertAfter('div.header .main-logo')

    }else {
      $('div.header p.search').insertAfter('div.header .utilities');
      $('.header-inner nav').insertBefore('div.header p.search')

    }
  }
  positionSearch()
  window.addEventListener('resize', positionSearch)

})